module.exports = "/_next/static/images/gurugram-fa8b4a8a79314baa127a56b1483a2431.webp";